import { userConstants } from "../../../constants/userConstants";

const initialState = {};

const accountManagementReducer = (state, action) => {
  if (typeof state === "undefined") {
    state = initialState;
  }
  switch (action.type) {
    case userConstants.GET_TENANT_LIST_SUCCESS:
      return Object.assign({}, state, {
        tenantList: action.responseData,
      });

    default:
      return state;
  }
};

export default accountManagementReducer;
